<template>
    <vs-sidebar
        click-not-close
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="editStaffConfig.isOpen"
        id="commission-setting"
    >
        <div class="mt-2 flex items-center justify-between px-6">
            <h4 class="text-2xl font-bold">Edit Staff Info</h4>
            <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>

        <div class="sidebar-content">
            <vs-tabs class="staff-tab-content" style="background: #fff;" v-model="active_tab" :key="tab_key">
                <vs-tab label="Commission">
                    <div class="con-tab-ejemplo p-3 py-0" style="height: inherit;">
                        <!-- <add-commission-content @FinishCommissionSetting="finishCommissionSetting" @SaveCommission="saveCommission" :editStaffConfig="editStaffConfig"></add-commission-content> -->
                        <update-commission-content :commissionList="commissionList" @closeSidebar="closeSidebar" @SaveCommission="saveCommission"></update-commission-content>
                    </div>
                </vs-tab>
                <vs-tab label="Salary + Commission">
                    <div class="con-tab-ejemplo p-3 py-0" style="height: inherit;">
                        <!-- <add-salary-commission-content @FinishCommissionSetting="finishCommissionSetting" @SaveSalaryCommission="saveCommission" :editStaffConfig="editStaffConfig"></add-salary-commission-content> -->
                        <update-salary-commission-content :commissionList="commissionList" @closeSidebar="closeSidebar" @SaveSalaryCommission="saveCommission"></update-salary-commission-content>
                    </div>
                </vs-tab>
                <vs-tab label="Salary">
                    <div class="con-tab-ejemplo p-3 py-0" style="height: inherit;">
                        <!-- <add-salary-content @FinishCommissionSetting="finishCommissionSetting" @SaveSalary="saveCommission" :editStaffConfig="editStaffConfig"></add-salary-content> -->
                        <update-salary-content :commissionList="commissionList" @closeSidebar="closeSidebar" @SaveSalary="saveCommission"></update-salary-content>
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
        <custom-loading :customLoadingConfig="customLoadingConfig" :isFromApprove="isFromApprove" :key="custom_loading_key + 'custom-loading'"></custom-loading>
    </vs-sidebar>
</template>

<script>
export default {
    name: 'payroll-edit-staff-sidebar',
    components: {
        SideBarItem: () => import("../../components/SideBarItem.vue")
    },
    props: {
        editStaffConfig: {
            type: Object,
            required: true
        },
        commissionList: {
            type: Object,
            required: true
        },
        active_staff: {
            type: Object,
            default: null
        },
        active_type: {
            type: Object,
            default: null
        },
        detail_filter_days: {
            type: Object,
            default: null
        }
    },
    watch: {
        editStaffConfig: {
            immediate: true,
            deep: true,
            handler() {
                // console.log(this.commissionList);
                if(this.editStaffConfig.isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        },
        active_type: {
            immediate: true,
            deep: true,
            handler() {
                if(this.active_type) {
                    if(this.active_type.type == 'commission') {
                        this.active_tab = 0;
                    } else if(this.active_type.type == 'salary') {
                        this.active_tab = 2;
                    } else {
                        this.active_tab = 1;
                    }
                    this.tab_key++;
                }
            }
        }
    },
    data() {
        return {
            isOpenLoading: false,
            active_tab: 0,
            tab_key: 0,
            customLoadingConfig: {
                isOpen: false
            },
            isFromApprove: false,
            custom_loading_key: 0
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Update Commission Failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        closeSidebar() {
            this.editStaffConfig.isOpen = false;
        },
        saveCommission(data) {
            data.staff_id = this.active_staff.user_id;
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch("staffList/UPDATE_COMMISION", data).then(() => {
                this.closeLoading();
                this.editStaffConfig.isOpen = false;
                const obj = {
                    id : data.staff_id,
                    commission_type : data.type,
                    page: this.currentPage,
                    "per-page": this.itemsPerPage,
                    filter: this.status,
                    detail_filter_days: this.detail_filter_days
                }
                // this.customLoadingConfig.isOpen = true;
                // setTimeout(() => {
                    this.$store.dispatch("staffList/CHANGE_STAFF_COMMISSION", obj);
                    this.$vs.notify({
                        title: "Notification",
                        text: "Update Commission Success",
                        color: "success",
                        position: "top-right"
                    });
                    let temp = {
                        staff_id: data.staff_id,
                        start_date: this.detail_filter_days.start_date,
                        end_date: this.detail_filter_days.end_date
                    }
                    
                    this.$emit('ChangeStaffCommission', temp);
                // }, 5000);
            }).catch(() => {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: 'Update Commission Failed',
                    acceptText: 'OK'
                })
            })
        }
    }
}
</script>